const cancelar_matricula = {
  path: "/cancelar-matricula",
  redirect: "/cancelar-matricula",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Matrículas",
  },
  children: [
    {
      path: "/cancelar-matricula",
      name: "cancelar_matricula",
      component: () =>
        import("@/views/CancelarMatricula/CancelarMatricula.vue"),
    },
  ],
};
export { cancelar_matricula };
